/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HousewareSprayIcon24Solid = forwardRef('HousewareSprayIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.912 1.443a.75.75 0 1 0-.574-1.386l-3.625 1.5a.75.75 0 0 0 .574 1.386l3.625-1.5Z" }),
        React.createElement("path", { d: "M4 4.5v2.938L16 5.62V4a2 2 0 0 0-2-2H6.5A2.5 2.5 0 0 0 4 4.5Z" }),
        React.createElement("path", { d: "M4 19V8.955l6-.909v2.75a1 1 0 0 0 .664.941l4.345 1.552A3 3 0 0 1 17 16.114V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3Z" }),
        React.createElement("path", { d: "M12 10V7.743l2-.303V10a1 1 0 0 1-2 0Z" }),
        React.createElement("path", { d: "M18.287 7.057a.75.75 0 0 0-.574 1.386l3.625 1.5a.75.75 0 0 0 .574-1.386l-3.625-1.5Z" }),
        React.createElement("path", { d: "M18 5.005a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z" })));
});
